import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import * as publicacionesService from '../../servicios/publicacionesService'
import ExposicionTipo from './ExposicionTipo'

const CANTIDAD_DECIMALES = 2

const Exposicion = ({ onChange, precioUnitario }) => {
  const [selectedOption, setOptionChequeado] = useState(0)
  const [exposiciones, setExposiciones] = useState([])

  const obtenerExposiciones = async () => {
    const exposicionRtn = await publicacionesService.buscarExposicion('')
    const exposicionesConPrecio = exposicionRtn.data.map((expo) => ({
      ...expo,
      precioCalculado:
        precioUnitario && !isNaN(Number(expo.precio))
          ? Number(((precioUnitario * expo.precio) / 100).toFixed(CANTIDAD_DECIMALES))
          : 0
    }))
    setExposiciones(exposicionesConPrecio)
  }

  useEffect(() => {
    obtenerExposiciones()
  }, [precioUnitario])

  const handleOptionChange = function (e) {
    setOptionChequeado(parseInt(e.target.value))
    onChange(e, 'num')
  }

  return (
    <div className="text-center">
      {exposiciones.map((exposicion) => (
        <ExposicionTipo
          key={exposicion.idPublicacionExposicion}
          name="idPublicacionExposicion"
          value={exposicion.idPublicacionExposicion}
          checked={selectedOption === exposicion.idPublicacionExposicion}
          onChange={handleOptionChange}
          exposicion={exposicion}
          precioCalculado={exposicion.precioCalculado}
        />
      ))}
    </div>
  )
}

Exposicion.propTypes = {
  onChange: PropTypes.func.isRequired,
  precioUnitario: PropTypes.number.isRequired
}

export default Exposicion
